import React from "react";

export const BgTransitionSentinel = () => (
    <div
        data-bg-transition-sentinel
        aria-hidden="true"
        style={{ display: "none" }}
    />
);
